import {
	UPDATE_FIELD,
	ADD_FIELD,
	REMOVE_FIELD,
	ADD_STAGE,
	REMOVE_STAGE,
	POPULATE_KEYWORDS,
	UPDATE_STATE_LOADING,
	UPDATE_STAGE_KEYS,
	UPDATE_FIELD_DROPDOWN_VALUES,
	UPDATE_DEPENDENT_FIELD_VALUES,
	UPDATE_IS_VALID_FLAG,
	FLUSH_QUERY,
	UPDATE_STAGES_MODEL
} from "../../actions/QueryBuilder/actionConstants";
import keywordsTranformation from "../../configurations/QueryBuilder/keywordTransformation";
import _ from "lodash";
import dropdownComputeEngine from "./dropdownComputeEngine";
import getKeywordType from "./getKeywordType";
import dynamicFieldEngine from "./dynamicFieldEngine";
import updateDependentFieldValuesRecursively from "./updateDependentFieldValuesRecursively";
/**
 * Returns whether value is valid or not
 * @param {*} value
 */
const checkValidityOfValue = value => {
	if (value instanceof Array) {
		return Boolean(value.length);
	} else if (value instanceof Object) {
		return Boolean(Object.keys(value).length);
	} else {
		return Boolean(value);
	}
};

/**
 * Takes fields as input and returns whether all its compulsary fields
 * have values or not. Returns true if valid, else false;
 * @param {*} fieldConfig
 */
const checkFields = fields => {
	let result = true;
	fields.forEach((field, index) => {
		if (field["is-repeatable"] && field["is-compulsary"]) {
			field.children.forEach((childSet, index) => {
				result = result && checkFields(childSet);
			});
		} else {
			result = field["is-compulsary"] ? result && checkValidityOfValue(field.value) : result;
		}
	});
	return result;
};

const queryModel = (state = { stagesModel: [] }, action) => {
	switch (action.type) {
		/**
		 * action: {
		 *  type,
		 *  field,
		 *  activeStageIdx,
		 * }
		 */
		case UPDATE_FIELD:
			var targetStage = _.cloneDeep(state.stagesModel[action.activeStageIdx]);
			var updatedFields = [];
			updatedFields = targetStage.fields.map((field, index) => {
				if (field["field-name"] === action.field["field-name"]) {
					field = action.field;
				}
				return field;
			});
			var updatedStage = targetStage;
			updatedStage.fields = updatedFields;
			var updatedStagesModel = state.stagesModel.map((stage, index) => {
				if (index === action.activeStageIdx) {
					return updatedStage;
				} else {
					return stage;
				}
			});
			return {
				stagesModel: updatedStagesModel
			};

		/**
		 * Adds field only where field has `is-repeatable` true
		 * action: {
		 *  type,
		 *  fieldConfig,
		 *  activeStageIdx,
		 * 	tableHash
		 * }
		 *
		 * TODO: Add handler for adding field at particular index
		 */
		case ADD_FIELD:
			var targetStage = { ...state.stagesModel[action.activeStageIdx] };
			const targetField = targetStage.fields.find(
				field => field["field-name"] === action.fieldConfig["field-name"]
			);
			const additionalChildset = targetField.fields.map(nestedField => {
				const nestedResult = { ...nestedField };
				nestedResult.parent = targetField;
				nestedResult.children = [];
				nestedResult.loading = false;
				nestedResult["dropdown-values"] = dropdownComputeEngine(
					undefined,
					nestedField,
					targetStage.keywords,
					action.tableHash,
					undefined,
					action.baseTable,
					state.stagesModel
				);
				return nestedResult;
			});
			targetField.children.push(additionalChildset);
			var updatedStage = targetStage;
			var updatedStagesModel = state.stagesModel.map((stage, index) => {
				if (index === action.activeStageIdx) {
					return updatedStage;
				} else {
					return stage;
				}
			});
			return {
				stagesModel: updatedStagesModel
			};
		/**
		 * action: {
		 *  type,
		 *  fieldIndex,
		 *  activeStageIdx
		 * }
		 */
		case REMOVE_FIELD:
			var targetStage = { ...state.stagesModel[action.activeStageIdx] };
			var updatedFields = targetStage.fields.filter((field, index) => index !== action.fieldIndex);
			var updatedStage = targetStage;
			updatedStage.fields = updatedFields;
			var updatedStagesModel = state.stagesModel.map((stage, index) => {
				if (index === action.activeStageIdx) {
					return updatedStage;
				} else {
					return stage;
				}
			});
			return {
				stagesModel: updatedStagesModel
			};
		/**
		 * action: {
		 *  type,
		 *  stageName,
		 *  fields
		 * }
		 *
		 * TODO: Add stage at a particular index
		 */
		case ADD_STAGE:
			var newStage = {
				"stage-name": "",
				fields: [],
				loading: true
			};
			var updatedStagesModel = [...state.stagesModel, newStage];
			return {
				stagesModel: updatedStagesModel
			};
		/**
		 * action: {
		 *  type,
		 *  stageIndex
		 * }
		 */
		case REMOVE_STAGE:
			var updatedStagesModel = state.stagesModel.filter((stage, index) => index !== action.stageIndex);
			return {
				stagesModel: updatedStagesModel
			};
		/**
		 * action: {
		 * 	type,
		 * 	activeStageIdx
		 * 	keywords
		 * }
		 */
		case POPULATE_KEYWORDS:
			var targetStage = { ...state.stagesModel[action.activeStageIdx] };
			// if (action.activeStageIdx === 0) {
			// 	targetStage.keywords = [...action.initKeywords];
			// 	var updatedStage = targetStage;
			// } else {
			// 	var prevStage = {
			// 		...state.stagesModel[action.activeStageIdx - 1]
			// 	};
			// 	var prevStageName = prevStage["stage-name"];
			// 	var nextStageKeywords = keywordsTranformation[prevStageName](
			// 		prevStage,
			// 		prevStage.keywords,
			// 		action.tableHash
			// 	);
			// 	var updatedStage = targetStage;
			// 	updatedStage.keywords = nextStageKeywords;
			// }
			var updatedStage = targetStage;
			updatedStage.keywords = [...action.keywords];
			var updatedStagesModel = state.stagesModel.map((stage, index) => {
				if (index === action.activeStageIdx) {
					return updatedStage;
				} else {
					return stage;
				}
			});
			return {
				stagesModel: updatedStagesModel
			};
		/**
		 * action: {
		 * 	type,
		 * 	activeStateIdx,
		 * 	value
		 * }
		 */
		case UPDATE_STATE_LOADING:
			var targetStage = { ...state.stagesModel[action.activeStageIdx] };
			targetStage.loading = action.value;
			var updatedStage = targetStage;
			var updatedStagesModel = state.stagesModel.map((stage, index) => {
				if (index === action.activeStageIdx) {
					return updatedStage;
				} else {
					return stage;
				}
			});
			return {
				stagesModel: updatedStagesModel
			};
		/**
		 * action: {
		 * 	type:
		 * 	activeStageIdx:
		 * 	updateObj: {
		 * 		key1,
		 * 		key2
		 * 	}
		 * }
		 */
		case UPDATE_STAGE_KEYS:
			var updatedStage = Object.assign(
				{},
				{ ...state.stagesModel[action.activeStageIdx] },
				{ ...action.updateObj }
			);
			var updatedStagesModel = state.stagesModel.map((stage, index) => {
				if (index === action.activeStageIdx) {
					return updatedStage;
				} else {
					return stage;
				}
			});
			return {
				stagesModel: updatedStagesModel
			};
		/**
		 * action: {
		 * 	type,
		 * 	activeStageIdx,
		 * 	tableHash
		 * }
		 */
		case UPDATE_FIELD_DROPDOWN_VALUES:
			var targetStage = { ...state.stagesModel[action.activeStageIdx] };
			targetStage.fields = targetStage.fields.map(field => {
				const updatedField = { ...field };
				if (updatedField.children.length) {
					updatedField.children = updatedField.children.map(childset => {
						return childset.map(children => {
							let updatedChildren = { ...children };
							if (children["dynamic-config"]) {
								const updateKeys = dynamicFieldEngine(
									children,
									targetStage.keywords,
									action.tableHash,
									childset,
									targetStage
								);
								Object.assign(updatedChildren, updateKeys);
							}
							updatedChildren["dropdown-values"] = dropdownComputeEngine(
								action.organizationId,
								updatedChildren,
								targetStage.keywords,
								action.tableHash,
								childset,
								action.baseTable,
								state.stagesModel
							);
							return updatedChildren;
						});
					});
				} else {
					if (updatedField["dynamic-config"]) {
						const updateKeys = dynamicFieldEngine(
							field,
							targetStage.keywords,
							action.tableHash,
							targetStage.fields,
							targetStage
						);
						// if (updateKeys.hasOwnProperty("value")) {
						// 	updateKeys.value =
						// 		updatedField.value || updateKeys.value;
						// }
						Object.assign(updatedField, updateKeys);
					}
					updatedField["dropdown-values"] = dropdownComputeEngine(
						action.organizationId,
						updatedField,
						targetStage.keywords,
						action.tableHash,
						targetStage.fields,
						action.baseTable,
						state.stagesModel
					);
				}
				return updatedField;
			});
			var updatedStage = targetStage;
			var updatedStagesModel = state.stagesModel.map((stage, index) => {
				if (index === action.activeStageIdx) {
					return updatedStage;
				} else {
					return stage;
				}
			});
			return {
				stagesModel: updatedStagesModel
			};

		case UPDATE_DEPENDENT_FIELD_VALUES:
			var targetStage = _.cloneDeep(state.stagesModel[action.activeStageIdx]);
			var updatedFields = [];
			updatedFields = updateDependentFieldValuesRecursively(targetStage.fields, action.field);

			var updatedStage = targetStage;
			updatedStage.fields = updatedFields;
			var updatedStagesModel = state.stagesModel.map((stage, index) => {
				if (index === action.activeStageIdx) {
					return updatedStage;
				} else {
					return stage;
				}
			});
			return {
				stagesModel: updatedStagesModel
			};

		case UPDATE_IS_VALID_FLAG:
			var targetStage = { ...state.stagesModel[action.activeStageIdx] };
			targetStage.isValid = checkFields(targetStage.fields);
			var updatedStage = targetStage;
			var updatedStagesModel = state.stagesModel.map((stage, index) => {
				if (index === action.activeStageIdx) {
					return updatedStage;
				} else {
					return stage;
				}
			});
			return {
				stagesModel: updatedStagesModel
			};
		/**
		 * action: {
		 * 	type
		 * }
		 */
		case FLUSH_QUERY:
			return {
				stagesModel: []
			};
		/**
		 * action: {
		 * 	stagesModel
		 * }
		 */
		case UPDATE_STAGES_MODEL:
			return {
				stagesModel: action.stagesModel
			};
		default:
			return state;
	}
};

export default queryModel;
